import { render, staticRenderFns } from "./ChartRadar.vue?vue&type=template&id=1acdfd44&scoped=true&"
import script from "./ChartRadar.vue?vue&type=script&lang=js&"
export * from "./ChartRadar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acdfd44",
  null
  
)

export default component.exports